import React from 'react';

interface StepperProps {
  steps: string[];
  currentStep: number;
  ariaLabel: string;
  /** Omit to make the steps read-only. */
  onStepClick?: (index: number) => void;
  className?: string;
}

const Stepper: React.FC<StepperProps> = ({
  steps,
  currentStep,
  ariaLabel,
  onStepClick,
  className,
}) => (
  <nav className={`stepper${className ? ` ${className}` : ''}`} aria-label={ariaLabel}>
    {steps.map((step, index) => {
      const complete = index < currentStep;
      const active = index === currentStep;
      return (
        <button
          type="button"
          key={index}
          className={`${active ? 'active' : ''}${complete ? ' complete' : ''}`}
          aria-current={active ? 'step' : undefined}
          disabled={!onStepClick}
          onClick={() => onStepClick?.(index)}
        >
          <span>{index + 1}</span>
          {step}
        </button>
      );
    })}
  </nav>
);

export default Stepper;
